module.exports = __webpack_public_path__ + "img/2_h_no.e8c48103.svg";